import { GET_CATEGORIES, GET_CATEGORY, GET_SUBCATEGORIES, GET_SUBCATEGORY, ERROR_CATEGORIES } from '../actions/types';

const initialState = {
  categories: [],
  category: '',
  subcategories: [],
  subcategory: '',
  loading: true,
  error: {}
}

export default function(state = initialState, action){
  const {type, payload} = action;

  switch(type){
    case GET_CATEGORIES:
      return{
        ...state,
        categories: payload,
        loading: false
      }
    case GET_CATEGORY:
      return{
        ...state,
        category: payload,
        loading: false
      }
    case GET_SUBCATEGORIES:
      return{
        ...state,
        subcategories: payload,
        loading: false
      }
    case GET_SUBCATEGORY:
      return{
        ...state,
        subcategory: payload,
        loading: false
      }
    case ERROR_CATEGORIES:
      return{
        ...state,
        error: payload,
        loading: false
      }
    default:
      return state;
  }
}